import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-629c26af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auto-paging" }
const _hoisted_2 = { class: "paging" }
const _hoisted_3 = { class: "totalPageAndTotal" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left" }, "上一页", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "pageIndex" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))

import { toRefs, ref, onMounted, computed, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PagingBar',
  props: {
    total: {},
    pagesize: {}
  },
  emits: ["updateData"],
  setup(__props: any, { emit }) {

const props = __props;

/* eslint-disable */

const { total, pagesize } = toRefs(props); // 只读的
const pageIndex = ref<number>(1);
const pageSize = ref<number>(pagesize.value);
onMounted(() => {
});
// 监听当前页码和每页显示的数据是否有变化，有则触发父组件的事件
watch([pageIndex, pageSize], (newIndex, newSize) => {
  emit('updateData', pageIndex.value, pageSize.value)
})
// 计算总页数是否有变化
const pageTotal = computed((): number => {
  return GetPageTotal(total.value, pageSize.value);
})
// 声明更新数据的事件

// 获取总页数
const GetPageTotal = (pTotal: number, pSize: number): number => {
  return Math.ceil(pTotal / pSize);
}
// 往前跳转1页
const previousPage = (): void => {
  if (pageIndex.value > 1) {
    pageIndex.value -= 1
  }
}
// 往后跳转1页
const nextPage = (): void => {
  if (pageIndex.value < pageTotal.value) {
    pageIndex.value += 1
  }
}
// 往前跳转5页
const previousSpeed = (): void => {
  const num = pageIndex.value - 5;
  if (num > 0) {
    pageIndex.value -= 5;
  } else {
    pageIndex.value = 1;
  }
}
// 往后跳转5页
const nextSpeed = (): void => {
  const num = pageIndex.value + 5
  if (num > pageTotal.value) {
    pageIndex.value = pageTotal.value;
  }
  else {
    pageIndex.value += 5;
  }
}
// <!-- 总页数减去当前页码大于3时调用 -->
const pageChange1 = (i: number): number => {
  return pageIndex.value + i - 3
}
// <!-- 总页数减去当前页码小于等于3时调用 -->
const pageChange2 = (i: number): number => {
  return pageTotal.value + i - 6
}
/* eslint-enable */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "共" + _toDisplayString(pageTotal.value) + "页 / " + _toDisplayString(_unref(total)) + "条  ", 1),
      _createElementVNode("div", {
        class: _normalizeClass(["previousAndNextPage", { notallowed: pageIndex.value == 1 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (previousPage()))
      }, _hoisted_5, 2),
      _createElementVNode("div", _hoisted_6, [
        (pageTotal.value <= 6)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(pageTotal.value, (i, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: _normalizeClass({ nowPage: pageIndex.value == i }),
                onClick: ($event: any) => (pageIndex.value = i)
              }, _toDisplayString(i), 11, _hoisted_7))
            }), 128))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (pageIndex.value < 5)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i, index) => {
                      return _createElementVNode("span", {
                        key: index,
                        class: _normalizeClass({ nowPage: pageIndex.value == i }),
                        onClick: ($event: any) => (pageIndex.value = i)
                      }, _toDisplayString(i), 11, _hoisted_8)
                    }), 64)),
                    _createElementVNode("span", {
                      class: "dot",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (nextSpeed()))
                    }, "..."),
                    _createElementVNode("span", {
                      class: "finally",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (pageIndex.value = pageTotal.value))
                    }, _toDisplayString(pageTotal.value), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("span", {
                      class: "first",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (pageIndex.value = 1))
                    }, "1"),
                    _createElementVNode("span", {
                      class: "dot",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (previousSpeed()))
                    }, "..."),
                    (pageTotal.value - pageIndex.value > 3)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i, index) => {
                            return _createElementVNode("span", {
                              key: index,
                              class: _normalizeClass({ nowPage: pageIndex.value == pageChange1(i) }),
                              onClick: ($event: any) => (pageIndex.value = pageChange1(i))
                            }, _toDisplayString(pageChange1(i)), 11, _hoisted_9)
                          }), 64)),
                          _createElementVNode("span", {
                            class: "dot",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (nextSpeed()))
                          }, "..."),
                          _createElementVNode("span", {
                            class: "finally",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (pageIndex.value = pageTotal.value))
                          }, _toDisplayString(pageTotal.value), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (pageTotal.value - pageIndex.value <= 3)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(6, (i, index) => {
                          return _createElementVNode("span", {
                            key: index,
                            class: _normalizeClass({ nowPage: pageIndex.value == pageChange2(i) }),
                            onClick: ($event: any) => (pageIndex.value = pageChange2(i))
                          }, _toDisplayString(pageChange2(i)), 11, _hoisted_10)
                        }), 64))
                      : _createCommentVNode("", true)
                  ], 64))
            ], 64))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["previousAndNextPage", { notallowed: pageIndex.value == pageTotal.value }]),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (nextPage()))
      }, [
        _createTextVNode(" 下一页"),
        _hoisted_11
      ], 2)
    ])
  ]))
}
}

})